/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Action } from './action';
import { FormGroup } from './formGroup';
import { FormField } from './formField';


export interface Stepper { 
    stepperId: string;
    stepperName: string;
    stepperType: string;
    assetUploadFlag: boolean;
    overviewHiddenFlag: boolean;
    communicationFlag: boolean;
    visibleHidden?: boolean;
    stepperGroupName: string;
    formFields?: Array<FormField>;
    formGroups?: Array<FormGroup>;
    actions?: Array<Action>;
}

